var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudentHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9L2.77778 7.22222M2.77778 7.22222L9 1L15.2222 7.22222M2.77778 7.22222V16.1111C2.77778 16.602 3.17575 17 3.66667 17H6.33333M15.2222 7.22222L17 9M15.2222 7.22222V16.1111C15.2222 16.602 14.8243 17 14.3333 17H11.6667M6.33333 17C6.82425 17 7.22222 16.602 7.22222 16.1111V12.5556C7.22222 12.0646 7.62019 11.6667 8.11111 11.6667H9.88889C10.3798 11.6667 10.7778 12.0646 10.7778 12.5556V16.1111C10.7778 16.602 11.1757 17 11.6667 17M6.33333 17H11.6667",
    stroke: "#2667B0",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentHomeIcon);
export default __webpack_public_path__ + "static/media/student_home_icon.2d8c0f666033f9b7569a5981fa44d2cb.svg";
export { ForwardRef as ReactComponent };